import axios from 'axios';
import { getAuthHeaders } from './auth';

const API_BASE = '/api';

export interface WhatsAppConfig {
  enabled: boolean;
  display_name: string;
  phone_number: string;
  phone_number_id: string;
  waba_id: string;
  business_id: string;
  access_token: string;        // masked on GET ("••••1234"), write-only
  app_secret: string;          // masked on GET, write-only
  webhook_verify_token: string;
  api_version: string;
  has_access_token?: boolean;
  has_app_secret?: boolean;
}

export interface WhatsAppScope {
  domain_id: number | null;
  slug: string;
  name_en: string;
  name_ar?: string;
  primary_color?: string | null;
  webhook_path: string;
  config: WhatsAppConfig;
}

export interface WhatsAppOverview {
  general: { webhook_path: string; config: WhatsAppConfig };
  domains: WhatsAppScope[];
  suggested_verify_token: string;
}

export const getWhatsApp = async (): Promise<WhatsAppOverview> => {
  const res = await axios.get(`${API_BASE}/admin/whatsapp`, { headers: getAuthHeaders() });
  return res.data;
};

export const saveWhatsApp = async (
  domainId: number | null,
  config: WhatsAppConfig,
): Promise<{ ok: boolean; config: WhatsAppConfig }> => {
  const res = await axios.put(
    `${API_BASE}/admin/whatsapp`,
    { domain_id: domainId, config },
    { headers: getAuthHeaders() },
  );
  return res.data;
};
